import React, { useEffect,useContext } from "react";
import { isMobile } from "react-device-detect";
import themeContext from "../../context/theme/ThemeContext";

const PrivacyPolicy = () => {
  const { themeName,getScrollBarStyleForTheme} = useContext(themeContext);
  useEffect(() => {
    document.title = "Privacy Policy";
  }, []);

  return (
    <>

<div className="custom-scroll study-list-filter-section"
     style={{ height: "calc(100vh - 55px)" }}>
      <div
        className={getScrollBarStyleForTheme(themeName,"common-modal-scroll")}
        style={{
          padding: isMobile?"20px 20px":"20px 150px",
          boxSizing: "border-box",
          height: "calc(100vh - 55px)",
          overflowY: "scroll",
        }}
      >
        <h1 style={{ textAlign: "center" }}>Privacy Policy</h1>
        <p style={{ textAlign: "justify" }}>
          At DeepTek Medical Imaging Pvt Ltd, we deeply care about privacy and
          confidentiality of Personally Identifiable Information (PII). We
          believe in transparency and we're committed to being upfront about our
          privacy practices. This privacy policy describes how DeepTek Medical
          Imaging Pvt Ltd collect, use and share information about you. This
          policy sets out how we process any personal data we collect from you
          or that you provide to us through every possible forms. We confirm
          that we will keep your Personally Identifiable Information (PII)
          secure. Please read the following carefully to understand what happens
          to Personally Identifiable Information (PII) that you choose to
          provide to company.
        </p>

        <h2 style={{ textAlign: "center" }}>
          Collection of Personally Identifiable Information (PII)
        </h2>
        <p style={{ textAlign: "justify" }}>
          Depending on the mode of communication you choose to interact with
          company (i.e. via electronic and/or otherwise methods) company may
          collect, store and use your Personally Identifiable Information (PII).
          Company may collect other information depending upon the context of
          service offerings you avail and/or via our online productised services
          or online assistance.
        </p>
        <p style={{ textAlign: "justify" }}>
          Person using our website; we may automatically collect information
          regarding the hardware and software of your computer. This information
          may include details such as Internet Protocol (IP) address, operating
          system, browser type and version, domain names.
        </p>

        <h2 style={{ textAlign: "center" }}>
          Use of Personally Identifiable Information (PII)
        </h2>
        <p style={{ textAlign: "justify" }}>
          Company collects and uses information only as necessary and so as
          company can provide the intended services to its customers. We may use
          your personal data for some of the following purposes
        </p>
        <ul style={{ textAlign: "justify" }}>
          <li>Account Maintenance</li>
          <li>Customer Service</li>
          <li>Customer Support</li>
          <li>Customer Engagement</li>
          <li>Internal Analytics</li>
          <li>Website Maintenance</li>
          <li>Legal legislations</li>
        </ul>
        <h2 style={{ textAlign: "center" }}>Information Sharing</h2>
        <p style={{ textAlign: "justify" }}>
          Company does not sell, lease or rent collected or received Personally
          Identifiable Information (PII) to any non-affiliate companies or
          entities otherwise. Any information you provide us shall be only upon
          consent and company ensures to address confidentiality and privacy
          until discarded completely. We shall; if need be; sharing your
          information with subsidiaries and trusted partners and our own
          services providers that support the services that we provide.
        </p>
        <p style={{ textAlign: "justify" }}>
          All such affiliates are prohibited from processing Personally
          Identifiable Information (PII) and are required to maintain the
          confidentiality and privacy of personal data. We shall use all
          reasonable efforts to ensure that personal data is not disclosed to
          regional/national institutions and authorities, unless required by
          legal or any other local (within country) or international (outside
          country) jurisdiction.
        </p>
        <h2 style={{ textAlign: "center" }}>
          What are cookies and how do we deal with them?
        </h2>
        <p style={{ textAlign: "justify" }}>
          A cookie is a piece of information that is stored on your computer's
          hard drive. It is normally sent by a web server to you and enables the
          server to collect information back from your site visit. This site may
          at times employ cookies as a tool to make the site function.
        </p>
        <h2 style={{ textAlign: "center" }}>
          Security of Personally Identifiable Information (PII)
        </h2>
        <p style={{ textAlign: "justify" }}>
          Personally Identifiable Information (PII) is of utmost importance to
          company that's why we have various policies and procedures in place to
          endure the confidentiality, privacy and integrity of Personally
          Identifiable Information (PII). Company also follows all the
          guidelines put forth by various standardised privacy compliances to
          ensure the protection of Personally Identifiable Information (PII).
        </p>
        <p style={{ textAlign: "justify" }}>
          Unfortunately, the transmission of information via the internet is not
          completely secure. Although we shall do our best to protect your
          personal data, we cannot guarantee the security of your data
          transmitted to our site; any transmission is at your own risk.
        </p>

        <h2 style={{ textAlign: "center" }}>
          Change and Removal of Personally Identifiable Information (PII)
        </h2>
        <p style={{ textAlign: "justify" }}>
          Please contact us at{" "}
          <a
            href="mailto:admin@deeptek.ai"
            // style={{ color: "#95c3eb" }} old color
            style={{ 
              color: themeName === "light" ? "#002BFF" : "#95c3eb", 
            }}
            className="support-email"
          >
            admin@deeptek.ai
          </a>{" "}
          for requests to access, correct, amend, delete, or limit the use or
          disclosure of your Personally Identifiable Information (PII). We will
          respond to your request within a reasonable timeframe. We will retain
          your information for as long as your account is active, as needed to
          provide you services and as necessary to comply with our legal
          legislative obligations, resolve disputes, and enforce our agreements.
        </p>
        <h2 style={{ textAlign: "center" }}>Data Subject Rights</h2>
        <p style={{ textAlign: "justify" }}>
          Considering the nature of the processing, we shall at all times
          cooperate with and assist our customers and relevant interested
          parties in meeting applicable timeframe limits and requirements under
          applicable data protection laws in relation to data subject's right:
        </p>
        <ul style={{ textAlign: "justify" }}>
          <li>of rectification of personal data,</li>
          <li>of erasure of personal data,</li>
          <li>to restriction of processing of personal data</li>
          <li> to portability of personal,</li>
          <li>
            to object to the lawfulness of the processing of personal data, and
          </li>
          <li>website Maintenance</li>
          <li>
            to not be subject to a decision based solely on automated
            processing.
          </li>
        </ul>
        <h2 style={{ textAlign: "center" }}>Breach Notification</h2>
        <p style={{ textAlign: "justify" }}>
          In case of data breach incidents involving Personally Identifiable
          Information (PII), we shall provide a reasonable and consistent
          response to the data subjects, controllers as well as the regulatory
          authority within stipulated time. In case you need to reach out to us
          regarding any breach incidences, you can contact us via email at{" "}
          <a
            href="mailto:admin@deeptek.ai"
            // style={{ color: "#95c3eb" }} old color
            style={{ 
              color: themeName === "light" ? "#002BFF" : "#95c3eb", 
            }}
            className="support-email"
          >
            admin@deeptek.ai
          </a>{" "}
          or you can directly Contact Company's Data Protection Officer.
        </p>
        <h2 style={{ textAlign: "center" }}>Your consent</h2>
        <p style={{ textAlign: "justify" }}>
          Your use of this website signifies your consent to us collecting and
          using the personal data you have provided in accordance with this
          policy statement. Should we choose to change these terms for any
          reason, the changes will be posted here so that you are always kept
          informed about the collection and use of your personal information,
          and when we disclose it.
        </p>
        <p style={{ textAlign: "justify" }}>
          We consider any personal information you provide as sensitive personal
          data within the meaning of the General Data Protection Regulations and
          this information will only be disclosed to other parties with your
          express consent.
        </p>
        <h2 style={{ textAlign: "center" }}>Contact Information</h2>
        <p style={{ textAlign: "justify" }}>
          If you wish to provide feedback or if you have questions or concerns,
          or wish to exercise your rights related to your Personally
          Identifiable Information (PII), please contact our Data Protection
          Officer at{" "}
          <a
            href="mailto:admin@deeptek.ai"
            // style={{ color: "#95c3eb" }}
            style={{ 
              color: themeName === "light" ? "#002BFF" : "#95c3eb", 
            }}
            className="support-email"
          >
            admin@deeptek.ai
          </a>
        </p>
      </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
